/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/25/21
 * Copyright All Rights Reserved
 */
import { pipe } from 'lodash/fp';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { withRouter } from 'react-router';
import { createUserPassword, fetchUser } from 'actions/userCreators';
import { CREATE_PASSWORD_FORM } from 'constants/forms';
import { selectAuthUserTokenIsSet, selectAuthUserOrgIsSet } from 'selectors/entities/users';
import CreatePasswordForm from './CreatePasswordForm';

const onSubmit = (values, dispatch) => (
  dispatch(createUserPassword(values.user, values.newPassword, dispatch))
    .then(response => dispatch(fetchUser(response.payload.authUserId)))
    .catch(response => Promise.reject(new SubmissionError({ _error: response.payload.message })))
);
const mapStateToProps = state => (
  {
    tokenIsSet: selectAuthUserTokenIsSet(state),
    orgIsSet: selectAuthUserOrgIsSet(state),
  }
);

export default pipe(
  withRouter,
  reduxForm({
    form: CREATE_PASSWORD_FORM,
    onSubmit,
  }),
  connect(mapStateToProps)
)(CreatePasswordForm);



// WEBPACK FOOTER //
// ./js/components/pages/SignIn/CreatePasswordForm/index.js